module.exports.init = () => {
    const { createModal } = require('../helpers/modalHelper');
    $(document).on('qfmodal:show', (ev, data) => {
        createModal(data);
    });
};
